import {request, setAuthInHeader} from "@/api/request";
import util from "../../mixins/util";
import {logout} from "@/utils/logout";

import {isDev} from "@/api/config";
const state = {
    UserInfo: {},
};

const getters = {
    getUserInfo: state => state.UserInfo,
};

const mutations = {
    updateUserInfo(state, obj) {
        state.UserInfo = obj.value;
    },
    resetUserInfo(state) {
        state.UserInfo = {};
    },

};

const actions = {
    setUserInfo({commit, rootState, dispatch}, {token}) {
        setAuthInHeader(token);

        let params = {}

        request.javaGet('v1/member/WEB/info', params).then(({data}) => data)
                .then((res) => {
                    let result = res.result;
                    if (res.code > 0 && !util.isEmpty(result.data)) {
                        const userInfo = res.result.data;
                        commit('updateUserInfo', {'value': userInfo});
                    } else {
                        commit('updateUserInfo', {'value': {}})
                        logout();
                    }
                }, () => {
                    console.log('error');
                })
    },
    changeUserInfo({commit, rootState}, {data}) {
        commit('updateUserInfo', {'value': data});
    },
    initUserInfo({commit, rootState}, {data}) {
        commit('resetUserInfo');
    },

};

export default {namespaced: true, state, getters, mutations, actions}
